import * as Connector from 'shared/connectors/userConnector';
import { USER } from 'store/types';

const init = () => ({
  type: USER.GET_ADVISERS_LIST_INIT,
});

export const success = data => ({
  type: USER.GET_ADVISERS_LIST_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: USER.GET_ADVISERS_LIST_FAILURE,
});

const getAdvisersList = uuid => async dispatch => {
  dispatch(init());
  try {
    const { data } = await Connector.getAdvisersList(uuid);
    dispatch(success(data));
  } catch (err) {
    dispatch(failure());
  }
};

export default getAdvisersList;
